module.exports = __webpack_public_path__ + "media/images/avatar-27f4507525615128ce3fa82ec4b1b2b2.svg";